/**
 * useAutoSound — настройка аккаунта «Автоматически включать звук».
 *
 * Значение принадлежит аккаунту (users.auto_sound). Зеркало в localStorage —
 * не отдельная правда, а КЭШ серверного: api/auth.ts обновляет его при
 * каждом получении профиля (логин, /user/me, поллинг), ЛК — при переключении
 * тумблера, а логаут очищает. Поэтому читаем кэш: он единственный канал,
 * который одинаково быстро отражает все три события и вдобавок будит
 * соседние вкладки через storage.
 *
 * AuthContext — подстраховка: если localStorage недоступен (private mode)
 * или кэш ещё не заполнен, берём значение прямо из профиля.
 */
import { useContext, useSyncExternalStore } from 'react'
import { AuthContext } from '../context/AuthContext'
import { readAutoSound, subscribeAutoSound } from '../utils/autoSound'

// useSyncExternalStore ждёт subscribe(onChange: () => void) — адаптируем
// подписку, которая отдаёт само значение.
const subscribe = (onChange: () => void) => subscribeAutoSound(() => onChange())

export function useAutoSound(): boolean {
	const cached = useSyncExternalStore(subscribe, readAutoSound, () => false)

	// Именно useContext, а не useAuth: тот бросает вне AuthProvider, а плеер
	// может рендериться в изолированном поддереве или в prerender-снапшоте —
	// там работаем по кэшу, без падения.
	const auth = useContext(AuthContext)
	if (cached) return true
	// Кэш пуст/недоступен, но профиль знает ответ — верим профилю
	return auth?.user ? Boolean(auth.user.auto_sound) : false
}
